module.exports = __webpack_public_path__ + "31cd78f09a31530501e3ff37819b3a95.svg";